import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "loaded", label: "Loaded" },
  { value: "dispatched", label: "Dispatched" },
  { value: "delivered", label: "Delivered" },
];

export const UNIT_OPTIONS = [
  { value: "tons", label: "Tons" },
  { value: "kg", label: "Kg" },
  { value: "quintals", label: "Quintals" },
];

export const PRODUCT_OPTIONS = [
  "Sharp Sand",
  "Soft Sand",
  "Bedding Sand",
  "20mm Ballast",
  "10mm Ballast",
  "10mm",
  "20mm",
  "40mm",
  "75mm",
  "Dirty Rejects",
  "PG",
  "20-5 Crushed",
  "Fines",
  "As Dug",
];

export const STATUS_STYLES = {
  pending: "text-yellow-400 bg-yellow-500/10 border-yellow-500/30",
  loaded: "text-blue-400 bg-blue-500/10 border-blue-500/30",
  dispatched: "text-orange-400 bg-orange-500/10 border-orange-500/30",
  delivered: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
};

export const STATUS_DOT = {
  pending: "bg-yellow-400",
  loaded: "bg-blue-400",
  dispatched: "bg-orange-400",
  delivered: "bg-emerald-400",
};

export function formatUnit(unit) {
  const u = (unit || "tons").toLowerCase();
  if (u === "kg") return "kg";
  if (u === "quintals") return "qtl";
  return "t";
}

export function todayISO() {
  // Local calendar date (YYYY-MM-DD). Avoid Date.toISOString() which returns
  // the UTC date and can be a day behind late in the evening.
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
